enum AnalyticsDashboardType {
  ALL = 'all',
}

export default AnalyticsDashboardType
